// SALM49ER----- Men's Skiff
// SALMFORMKITE- Men's Kite
// SALMILCA7---- Men's Dinghy
// SALMIQFOIL--- Men's Windsurfing
// SALW49ERFX--- Women's Skiff
// SALWFORMKITE- Women's Kite
// SALWILCA6---- Women's Dinghy
// SALWIQFOIL--- Women's Windsurfing
// SALX470------ Mixed Dinghy
// SALXNACRA17-- Mixed Multihull

const KITE = /SAL.FORMKITE-.+/

const WINDSURFING = /SAL.IQFOIL---.+/

const SKIFF = /SAL.49ER..---.+/

const SINGLE_DINGHY = /SAL.ILCA.----.+/

const MIXED_DINGHY = /SALX470------.+/

const MIXED_MULTIHULL = /SALXNACRA17--.+/

const FINALS = /SAL...................(FNL-|QFNL|SFNL).+/

const KITE_SEMIFINAL = /SAL.FORMKITE----------SFNL000.00../

const KITE_FINAL = /SAL.FORMKITE----------FNL-000.00../

export const isKite = (rsc) => {
    return KITE.test(rsc);
}

export const isWindsurfing = (rsc) => {
    return WINDSURFING.test(rsc);
}

export const isSkiff = (rsc) => {
    return SKIFF.test(rsc);
}

export const isSingleDinghy = (rsc) => {
    return SINGLE_DINGHY.test(rsc);
}

export const isMixedDinghy = (rsc) => {
    return MIXED_DINGHY.test(rsc);
}

export const isDinghy = (rsc) => {
    return isSingleDinghy(rsc) || isMixedDinghy(rsc);
}

export const isMultiHull = (rsc) => {
    return MIXED_MULTIHULL.test(rsc);
}

export const numberOfCurrentLeadersDisplayed = (rsc) => { 
    return isSingleDinghy(rsc) || isMixedDinghy(rsc) || isSkiff(rsc) || isMultiHull(rsc) ? 4 : 3
}

export const isFinals = (rsc) => {
    return FINALS.test(rsc);
}

export const isSemiFinal = (phase) => {
    return "SFNL" === phase;
}

export const isKiteSemifinal = (rsc) => {
    return KITE_SEMIFINAL.test(rsc);
}

export const isKiteFinal = (rsc) => {
    return KITE_FINAL.test(rsc);
}

export const getKiteSemisRsc = (rsc) => {
    let out = [];
    if (isKiteSemifinal(rsc)) {
        out.push(rsc.slice(0, 29) + '1' + rsc.slice(30, 34));
        out.push(rsc.slice(0, 29) + '2' + rsc.slice(30, 34));
    }
    return out;
}
